import React from 'react'
import styles from './Header.module.scss'

function Header({ children }: any) {
  return <div className={styles.root}>{children}</div>
}

export default Header
